import { render, staticRenderFns } from "./EmployeeMergeResolutions.vue?vue&type=template&id=930854d6&scoped=true&"
import script from "./EmployeeMergeResolutions.vue?vue&type=script&lang=js&"
export * from "./EmployeeMergeResolutions.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeMergeResolutions.vue?vue&type=style&index=0&id=930854d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930854d6",
  null
  
)

export default component.exports